export default __webpack_public_path__ + "src/images/home/agreement classified-949325b2471acd008390164d061f0541.png";